// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1gWcV","error":"Textarea_error__23bms","readonly":"Textarea_readonly__32Q0d","disabled":"Textarea_disabled__3BqQR"};